import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationResidenceTodoProfilApiService } from '@_services/api/organization-residence-todo-profil-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationResidenceTodoProfilEffects } from './organization-residence-todo-profil-generated.effects';

@Injectable()
export class OrganizationResidenceTodoProfilEffects extends GeneratedOrganizationResidenceTodoProfilEffects {
  constructor(
    actions$: Actions,
    organizationResidenceTodoProfilApiService: OrganizationResidenceTodoProfilApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationResidenceTodoProfilApiService, store$);
  }
}
